(ns cljsjs.html2canvas
  (:require ["html2canvas" :as html2canvas]))

;;npm install react-draggable(?)
(js/goog.exportSymbol "html2canvas" html2canvas)
